<template>
    <div v-loading="loading">
        <section>
            <article class="mt-5">
            <div class="container mt-5">
                <div class="row w-100 mb-4">
                <div class="col-12 pl-3 px-0 mb-0 text-left">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/smartlodge/admin/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Review</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                </div>
                <h1 style="font-size: 1.5em; font-weight: 600;">Review:</h1>
                <div
                style="display: flex; align-items:center; justify-content: space-between;"
                class="search_add_section"
                >
                <div style="width: 50%;">
                    <input
                    type="text"
                    v-model.trim="filters[0].value"
                    placeholder="Search by Review Message"
                    class="search_by_input form-control"
                    spellcheck="off"
                    />
                </div>
                <div> 
                    
                    <el-button
                        type="warning"
                        :disabled="false"
                        @click="generateQRCodeAndDownloadPDF()"
                        round
                    >
                        Generate QR Code
                    </el-button>
                </div>
                </div>
                <hr />
    
                <div
                v-loading="loading || is_changing"
                class="table-responsive mb-5"
                >
                <data-tables
                    :data="reviews"
                    :table-props="tableProps"
                    :pagination-props="{ pageSizes: [5, 20, 25, 50, 100] }"
                    type="expand"
                    :filters="filters"
                >
    
                    <div slot="empty">
                    <ScaleOut
                        v-if="isLoading && !loadingError"
                        class="mt-3"
                        :background="'#164B70'"
                    />
                    <div
                        @click="getReview"
                        v-else-if="!isLoading && loadingError"
                        style="cursor: pointer"
                    >
                        Unable to Load reviews Now. Please click here to retry
                    </div>
                    <div v-if="!isLoading && !loadingError">No reviews</div>
                    </div>
    
                    <el-table-column
                    label="#"
                    :show-overflow-tooltip="false"
                    label-class-name="text-center"
                    class-name="text-center"
                    width="80px"
                    >
                    <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                    </template>
                    </el-table-column>
    
                    <el-table-column
                    label="Review Info"
                    :show-overflow-tooltip="false"
                    label-class-name="text-left"
                    class-name="text-left"
                    >
                    <template slot-scope="scope">
                      <el-rate
                        v-model="scope.row.rating"
                        :colors="colors">
                      </el-rate>
                      {{ scope.row.reviewMessage }}
                    </template>
                    </el-table-column>
    
                    <el-table-column
                    label="Actions"
                    :show-overflow-tooltip="false"
                    label-class-name="text-center"
                    class-name="text-center"
                    >
                    <template slot-scope="scope">
                        <el-tooltip
                            content="Delete"
                            placement="top"
                        >
                            <el-button
                            type="danger"
                            :disabled="$store.state.userRoles !== 'SUPER_ADMIN'"
                            @click="deleteReview(scope.row.feedbackID)"
                            icon="el-icon-delete"
                            circle
                            ></el-button>
                        </el-tooltip>
                    </template>
                    </el-table-column>
    
                </data-tables>
                </div>
    
            </div>
            </article>
        </section>

        
    </div>
  </template>
  
  <script>
  import QRCode from 'qrcode';
  import jsPDF from 'jspdf';
  import ScaleOut from "@/components/backoffice/scale-out-component.vue";
  import { format, parseISO } from "date-fns";
  export default {
    components: {
      ScaleOut,
    },
  
    data() {
      return {
        loading: false,
        isLoading: false,
        qrCodeDataUrl: '',
        reviews: [],
        
        tableProps: {
          border: true,
          stripe: true,
        },
        filters: [
          {
            prop: "reviewMessage",
            value: "",
          },
        ],
        loadingError: false,
        
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'], // same as { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
      
      };
    },
  
    computed: {
      formattedDate() {
        return (dateString) => format(parseISO(dateString), "do MMM yyyy hh:mma");
      },
    },
  
    mounted() {
      this.getReview();
    },
  
    methods: {
  
      async getReview() {
        this.isLoading = true;
        this.isLoadingError = false;
        try {
          //TODO: MAKE THIS REQUEST DYNAMIC AND NOT STATIC
          let request = await this.$http.get(`reviews/general`);
          if (request.data.success && request.data.message === "REVIEWS_FETCHED_SUCCESSFULLY") {
            this.reviews = request.data.reviews;
          } else throw "UNEXPECTED_RESPONSE_RECEIVED";
        } catch (error) {
          this.isLoadingError = true;
          //TODO: REPORT THIS TO AN ERROR REPORTING SERVICE
          this.$notify({
            title: "Operation Failed",
            message: "Unable to fetch reviews now, please try again",
            type: "error",
          });
        } finally {
          this.isLoading = false;
        }
      },
  
      async deleteReview(feedbackID) {
        this.$confirm(
          // eslint-disable-line no-unreachable
          "This will permanently delete this Review. Do you want to Continue?",
          "Confirm delete",
          {
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        )
          .then(async () => {
            try {
              this.deleting = true;
              let request = await this.$http.delete(`reviews/${feedbackID}`);
              if (
                request.data.success &&
                request.data.message === "REVIEW_DELETED_SUCCESSFULLY"
              ) {
                this.getReview();
                this.$notify({
                  title: "Success",
                  message: "Review deleted successfully!",
                  type: "success",
                });
              } else {
                throw "UNEXPECTED_RESPONSE";
              }
            } catch (error) {
              if (error.message == "Network Error") {
                this.loadingError = true;
                return this.$notify({
                  title: "Connection failed",
                  message: "A network error occurred, please try again.",
                  type: "error",
                });
              }
              this.$notify({
                title: "Unable to Delete",
                message: "Unable to delete the Review, Please try again",
                type: "error",
              });
            } finally {
              this.deleting = false;
            }
          })
          .catch(() => {
            //
          });
      },

      
      generateQRCode() {
        // Construct the detail page URL
        const detailPageUrl = `${window.location.origin}/general-reviews`;

        // Generate the QR code
        QRCode.toDataURL(detailPageUrl)
          .then((url) => {
            this.qrCodeDataUrl = url;
          })
          .catch((err) => {
            console.error(err);
          });
      },

      generateQRCodeAndDownloadPDF() {
        // Construct the detail page URL
        const detailPageUrl = `${window.location.origin}/general-reviews`;

        // Generate the QR code
        QRCode.toDataURL(detailPageUrl)
          .then((url) => {
            // Create a new PDF document
            const doc = new jsPDF();

            // Page dimensions
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            // Header section
            const headerTitle = "Happy with our service?";
            doc.setFontSize(24);
            doc.setFont('helvetica', 'bold');
            const headerTitleWidth = doc.getTextWidth(headerTitle);
            doc.text(headerTitle, (pageWidth - headerTitleWidth) / 2, 30);

            // Paragraph below the header
            const paragraph = `Help spread the word. Review Acacia Wilderness Mweya.`;
            doc.setFontSize(16);
            doc.setFont('helvetica', 'normal');
            const paragraphWidth = doc.getTextWidth(paragraph);
            doc.text(paragraph, (pageWidth - paragraphWidth) / 2, 45);

            // QR code section
            const qrCodeSize = 80; // Size of the QR code
            const qrCodeX = (pageWidth - qrCodeSize) / 2;
            const qrCodeY = (pageHeight - qrCodeSize) / 2;
            doc.addImage(url, 'PNG', qrCodeX, qrCodeY, qrCodeSize, qrCodeSize);

            // Footer section with business name
            const footerTitle = "Acacia Wilderness Mweya";
            doc.setFontSize(20);
            doc.setFont('helvetica', 'bold');
            const footerTitleWidth = doc.getTextWidth(footerTitle);
            doc.text(footerTitle, (pageWidth - footerTitleWidth) / 2, pageHeight - 30);

            // Footer paragraph
            const footerText = "Scan QR Code to Review Acacia Wilderness Mweya";
            doc.setFontSize(14);
            doc.setFont('helvetica', 'normal');
            const footerTextWidth = doc.getTextWidth(footerText);
            doc.text(footerText, (pageWidth - footerTextWidth) / 2, pageHeight - 15);

            // Save the PDF with a filename
            doc.save(`Review_Acacia_Wilderness_Mweya_Lodge.pdf`);
          })
          .catch((err) => {
            console.error("Error generating QR code:", err);
          });
      },
    },
  };
  </script>
  
  <style>
  .el-form-item {
    margin-bottom: 0px;
  }
  
  .el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0 0 0px;
  }
  label {
    display: inline-block;
    margin-bottom: 0px;
  }
  </style>